import { useNavigate, useParams } from "react-router-dom";
import UsageDashboard from "@/components/usage/UsageDashboard";

export default function MasterApiKeyUsagePage() {
  const { keyId } = useParams();
  const navigate = useNavigate();
  return (
    <UsageDashboard
      basePath={`/master/api-keys/${keyId}`}
      variant="master"
      keyId={keyId}
      onBack={() => navigate("/master/api-usage")}
    />
  );
}
